import { IconComponent } from './types';

const RowIcon: IconComponent = ({ className }) => {
  return (
    <svg
      className={className}
      width="12"
      height="3"
      viewBox="0 0 12 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0.799999L10 1.8L3 1.8L3 0.799999L10 0.799999Z"
        fill="currentColor"
      />
      <path
        d="M10.7272 2.51724C10.0321 2.51724 9.46863 1.95374 9.46863 1.25862C9.46863 0.563504 10.0321 -8.54006e-08 10.7272 -5.50161e-08C11.4224 -2.46315e-08 11.9859 0.563504 11.9859 1.25862C11.9859 1.95374 11.4224 2.51724 10.7272 2.51724Z"
        fill="currentColor"
      />
      <path
        d="M2.0313 2.51725C1.33618 2.51725 0.772675 1.95375 0.772675 1.25863C0.772675 0.563511 1.33618 7.54399e-06 2.0313 7.57438e-06C2.72641 7.60476e-06 3.28992 0.563511 3.28992 1.25863C3.28992 1.95375 2.72641 2.51725 2.0313 2.51725Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RowIcon;
